<template>
  <section class="w-full shrink-0 space-y-3">
    <div class="shimmer h-7 w-full rounded-2xl"></div>
    <div
      class="no-scrollbar -mx-4 flex shrink-0 items-center space-x-3 overflow-x-scroll px-4"
    >
      <div
        v-for="i in 2"
        :key="i"
        class="shimmer h-40 min-w-64 rounded-2xl"
      ></div>
    </div>
  </section>
</template>
